import React from 'react';

import { workspaceModalSteps } from '@/config/contents';
import { createWorkspaceSchema, workspaceSchema } from '@/schemas';
import { isCompanyEmail } from 'free-email-domains-list';
import { useSession } from 'next-auth/react';
import { z } from 'zod';

import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

import { useCreateWorkspaceModal } from '../store/use-create-workspace-modal';
import { CreateWorkspaceForm } from './create-workspace-form';

export type WorkspaceDAO = {
    userId: z.infer<typeof createWorkspaceSchema>['userId'];
    workspace: z.infer<typeof workspaceSchema>;
    // channel: z.infer<typeof channelSchema>;
};

export function CreateWorkspaceModal() {
    const {
        openWorkspaceCreateModal: open,
        setOpenWorkspaceCreateModal: setOpen,
    } = useCreateWorkspaceModal();
    const { data: session } = useSession();

    const handleClose = () => {
        setOpen(false);
    };

    const preFetchCompanyInfo = React.useMemo(() => {
        const hasCompanyEmail = isCompanyEmail(session?.user?.email ?? '');
        if (hasCompanyEmail) {
            const suggestedDomain = session?.user?.email?.split('@')[1];
            return {
                suggestedDomain: suggestedDomain ?? null,
                hasCompanyEmail,
            };
        }
        return { suggestedDomain: null, hasCompanyEmail };
    }, [session?.user?.email]);

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent
                className={`flex flex-col max-w-[800px] w-[90vw] h-auto  max-h-[90vh] p-6 ${
                    preFetchCompanyInfo.hasCompanyEmail
                        ? 'max-w-[800px]'
                        : 'max-w-[400px]'
                }`}
            >
                <DialogHeader className="flex-shrink-0">
                    <DialogTitle>
                        {workspaceModalSteps.workspaceTitle}
                    </DialogTitle>
                </DialogHeader>
                <div className="flex-1 flex flex-col overflow-y-auto">
                    <CreateWorkspaceForm
                        session={session}
                        suggestedDomain={preFetchCompanyInfo.suggestedDomain}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}
